var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifierMobile = function SvgMagnifierMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifier_mobile_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".magnifier_mobile_svg__st0{fill:none;stroke:#000;stroke-width:1.3;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "magnifier_mobile_svg__st0",
    cx: 22.3,
    cy: 21.4,
    r: 7.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "magnifier_mobile_svg__st0",
    d: "m28 27.5 5.1 5.2",
    id: "magnifier_mobile_svg__Layer_5"
  })));
};
export default SvgMagnifierMobile;